module.exports = __webpack_public_path__ + "static/media/hero-image.d24da8cc.png";